import React from 'react';

import FallbackSilk from '../../silks/fallback-silk.svg';
import Jacket from '../Jacket/Jacket';

interface SilkProps {
  silkUrl: string | undefined;
  isGreyhounds?: boolean;
  sortPriority?: number;
  raceCountryCode?: string;
}

const Silk: React.FC<SilkProps> = ({ silkUrl, isGreyhounds, sortPriority, raceCountryCode }) => {
  if (isGreyhounds && sortPriority && raceCountryCode) {
    return <Jacket trapNumber={sortPriority} raceCountryCode={raceCountryCode} />;
  }

  return silkUrl ? <img alt="" src={silkUrl} /> : <FallbackSilk />;
};

export default Silk;
